import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import { OBJECT_PROPERTY, FIELD_DATA, FETCHED_OBJECT_PROPERTY, ENROLLMENT_EVENT_PROPERTY, ENROLLMENT_DATASET_COLUMN } from 'automation-ui-formula-editor/formula-editor/data-passing/constants/DataSourceOptions';
import StaticBranchActionMetadata from 'automation-ui-action-features/actions/static-branch/StaticBranchActionMetadata';
import StaticBranchActionDetailFromDataToken from 'automation-ui-action-features/actions/static-branch/StaticBranchActionDetailFromDataToken';
import { jsx as _jsx } from "react/jsx-runtime";
class StaticBranchActionDetail extends Component {
  constructor(...args) {
    super(...args);
    this.getFieldDataOptions = () => {
      const {
        actionMetadata,
        getHeaderTitle
      } = this.props;
      const outputsByActionId = this.getActionOutputs();
      const sourceActionId = actionMetadata.getValueIdentifierActionId();
      const sourceActionOutputName = actionMetadata.getValueIdentifierDataKey();
      const sourceActionHeaderTitle = sourceActionId && getHeaderTitle({
        actionId: sourceActionId
      });
      const currentActionOutputs = outputsByActionId[sourceActionId];
      const options = {
        inputValueName: '',
        inputActionLabel: ''
      };
      if (currentActionOutputs) {
        options.inputValueName = /*#__PURE__*/_jsx("b", {
          children: currentActionOutputs.outputLabelsByFieldName[sourceActionOutputName] || sourceActionOutputName
        });
        options.inputActionLabel = /*#__PURE__*/_jsx("b", {
          children: sourceActionHeaderTitle
        });
      }
      return options;
    };
    this.getActionOutputs = () => {
      const {
        actionOutputs
      } = this.props;
      const outputsByActionId = {};
      actionOutputs.forEach(({
        outputFieldDefinitions,
        actionId: sourceActionId
      }) => {
        const outputLabelsByFieldName = {};
        outputFieldDefinitions.forEach(({
          typeDefinition: {
            name,
            label
          }
        }) => {
          outputLabelsByFieldName[name] = label;
        });
        outputsByActionId[sourceActionId] = {
          outputLabelsByFieldName
        };
      });
      return outputsByActionId;
    };
  }
  render() {
    const {
      actionMetadata,
      flowObjectTypeId
    } = this.props;
    const inputType = actionMetadata.getInputType();
    if (inputType === OBJECT_PROPERTY) {
      const propertyName = actionMetadata.getInputValue().getPropertyName();
      return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "automation-ui-action-features.action-features.static-branch.action-detail.enrolled-object_cob",
        objectTypeId: flowObjectTypeId,
        options: {
          sourcePropertyName: /*#__PURE__*/_jsx(PropertyName, {
            propertyName: propertyName,
            objectTypeId: flowObjectTypeId
          })
        }
      });
    } else if (inputType === FIELD_DATA) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.static-branch.action-detail.data-passing",
        options: Object.assign({}, this.getFieldDataOptions())
      });
    } else if (inputType === FETCHED_OBJECT_PROPERTY || inputType === ENROLLMENT_EVENT_PROPERTY || inputType === ENROLLMENT_DATASET_COLUMN) {
      const token = actionMetadata.getInputValue().getPropertyToken();
      return /*#__PURE__*/_jsx(StaticBranchActionDetailFromDataToken, {
        langKey: "automation-ui-action-features.action-features.static-branch.action-detail.fetched-object",
        token: token
      });
    } else {
      return /*#__PURE__*/_jsx(MissingLabel, {
        type: "name"
      });
    }
  }
}
StaticBranchActionDetail.defaultProps = {
  actionOutputs: []
};
StaticBranchActionDetail.propTypes = {
  actionMetadata: PropTypes.instanceOf(StaticBranchActionMetadata).isRequired,
  flowObjectTypeId: PropTypes.string.isRequired,
  getHeaderTitle: PropTypes.func,
  actionOutputs: PropTypes.arrayOf(PropTypes.shape({
    actionId: PropTypes.number.isRequired,
    outputFieldDefinitions: PropTypes.array.isRequired
  }))
};
export default StaticBranchActionDetail;